import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/EditWebsite.css";

const EditWebsite = () => {
  const [ads, setAds] = useState([]);
  const [newAd, setNewAd] = useState({
    image: null,
    hoverText: "",
  });
  const [editingAd, setEditingAd] = useState(null);
  const [categories, setCategories] = useState([]);
  const [selectedCarouselCategories, setSelectedCarouselCategories] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetchAds();
    fetchCategories();
    fetchCarouselCategories();
  }, []);

  const fetchAds = async () => {
    try {
      const response = await axios.get( `${API_BASE_URL}/api/advertisements`);
      setAds(response.data);
    } catch (error) {
      console.error("Error fetching ads:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get( `${API_BASE_URL}/api/products/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };


  const handleCarouselCategoryChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map((option) =>
      parseInt(option.value)
    );
    setSelectedCarouselCategories(selectedOptions);
  };

const fetchCarouselCategories = async () => {
  try {
    const token = localStorage.getItem("token"); // Get the token from localStorage
    if (!token) {
      alert("You must be logged in to perform this action.");
      return;
    }

    const response = await axios.get(
       `${API_BASE_URL}/api/products/settings/carousel-categories`,
      {
        headers: {
          Authorization: `Bearer ${token}`, // Include the token in the headers
        },
      }
    );
    setSelectedCarouselCategories(response.data);
  } catch (error) {
    console.error("Error fetching carousel categories:", error);
    alert("Failed to fetch carousel categories. Please try again.");
  }
};
// Add this function to your component
const saveCarouselCategories = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("You must be logged in to perform this action.");
      return;
    }

    await axios.post(
       `${API_BASE_URL}/api/products/settings/carousel-categories`,
      selectedCarouselCategories,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    alert("Carousel categories updated successfully!");
  } catch (error) {
    console.error("Error saving carousel categories:", error);
    alert("Failed to save carousel categories. Please try again.");
  }
};
  const handleImageChange = (e) => {
    setNewAd({ ...newAd, image: e.target.files[0] });
  };

  const handleTextChange = (e) => {
    setNewAd({ ...newAd, hoverText: e.target.value });
  };

  const handleEditImageChange = (e) => {
    setEditingAd({
      ...editingAd,
      imageFile: e.target.files[0],
      imageUrl: URL.createObjectURL(e.target.files[0]),
    });
  };

  const handleEditTextChange = (e) => {
    setEditingAd({ ...editingAd, hoverText: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("image", newAd.image);
    formData.append("text", newAd.hoverText);

    try {
      const token = localStorage.getItem("token");
      await axios.post( `${API_BASE_URL}/api/advertisements`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });

      setNewAd({ image: null, hoverText: "" });
      await fetchAds();
    } catch (error) {
      console.error("Creation failed:", error.response?.data || error.message);
      alert(`Error: ${error.response?.data?.message || "Failed to create ad"}`);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (editingAd.imageFile) {
      formData.append("image", editingAd.imageFile);
    }
    formData.append("text", editingAd.hoverText);

    try {
      const token = localStorage.getItem("token");
      await axios.put(
         `${API_BASE_URL}/api/advertisements/${editingAd.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setEditingAd(null);
      await fetchAds();
    } catch (error) {
      console.error("Update failed:", error.response?.data || error.message);
      alert(`Error: ${error.response?.data?.message || "Failed to update ad"}`);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this advertisement?")) {
      try {
        const token = localStorage.getItem("token");
        await axios.delete( `${API_BASE_URL}/api/advertisements/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        await fetchAds();
      } catch (error) {
        console.error("Deletion failed:", error.response?.data || error.message);
        alert(`Error: ${error.response?.data?.message || "Failed to delete ad"}`);
      }
    }
  };

  return (
    <div className="edit-website">
      <h2>Uredi Reklame</h2>

      {/* Add New Advertisement Form */}
      <div className="ad-edit">
        <h3>{editingAd ? "Edit Advertisement" : "Add New Advertisement"}</h3>
        <form onSubmit={editingAd ? handleEditSubmit : handleSubmit}>
          <div className="ad-controls">
            <input
              type="file"
              accept="image/*"
              onChange={editingAd ? handleEditImageChange : handleImageChange}
              required={!editingAd}
            />
            {editingAd && (
              <div className="current-image-preview">
                <img
                  src={editingAd.imageUrl}
                  alt="Current"
                  style={{ maxWidth: "200px", maxHeight: "150px" }}
                />
                <p>Trenutna Slika</p>
              </div>
            )}
            <textarea
              placeholder="Unesite tekst"
              value={editingAd?.hoverText || newAd.hoverText}
              onChange={editingAd ? handleEditTextChange : handleTextChange}
              required
            />
            <div className="form-buttons">
              <button type="submit" className="save-button">
                {editingAd ? "Ažuriraj Reklamu" : "Objavi Reklamu"}
              </button>
              {editingAd && (
                <button
                  type="button"
                  className="cancel-button"
                  onClick={() => setEditingAd(null)}
                >
                  Otkaži
                </button>
              )}
            </div>
          </div>
        </form>
      </div>

      {/* Existing Ads Preview */}
      <div className="advertisements-edit">
        {ads.map((ad) => (
          <div key={ad.id} className="ad-edit">
            {/* Image and Text Preview */}
            <div className="ad-image-preview">
              <img src={ad.imageUrl} alt={`Ad ${ad.id}`} />
              <div className="ad-text-preview">{ad.hoverText}</div>
            </div>

            {/* Edit/Delete Buttons */}
            <div className="ad-controls-buttons">
              <button
                className="edit-button"
                onClick={() =>
                  setEditingAd({
                    id: ad.id,
                    hoverText: ad.hoverText,
                    imageUrl: ad.imageUrl,
                    imageFile: null,
                  })
                }
              >
                Uredi
              </button>
              <button
                className="delete-button"
                onClick={() => handleDelete(ad.id)}
              >
                Izbriši
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Carousel Categories Section */}
<div className="carousel-categories-edit">
  <h3>Odaberi Kategorije za Dodatne Karusele (Max 5)</h3>
  <div className="categories-checkbox-list">
    {categories.map((category) => (
      <label key={category.id} className="category-checkbox-label">
        <input
          type="checkbox"
          checked={selectedCarouselCategories.includes(category.id)}
          onChange={(e) => {
            if (e.target.checked) {
              if (selectedCarouselCategories.length < 5) {
                setSelectedCarouselCategories([...selectedCarouselCategories, category.id]);
              }
            } else {
              setSelectedCarouselCategories(
                selectedCarouselCategories.filter((id) => id !== category.id)
              );
            }
          }}
          disabled={
            selectedCarouselCategories.length >= 5 &&
            !selectedCarouselCategories.includes(category.id)
          }
        />
        {category.name}
      </label>
    ))}
  </div>
  <div className="selection-counter">
    Selected: {selectedCarouselCategories.length}/5
  </div>
  <button onClick={saveCarouselCategories} className="save-button">
    Sačuvaj Kategorije
  </button>
</div>
    </div>
  );
};

export default EditWebsite;